import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import MobileScreen from '@nykaa/nes-auth/components/Welcome/MobileLogin';
import Toast, { VARIANT } from '@nykaa/nes-ui-components/Toast';
import { SUBTITLES, TOAST_TIMER } from '@nykaa/nes-auth-shared/constants';
import useAuthData from '@nykaa/nes-auth-shared/hooks/useAuthData';
import { WelcomeScreenProps } from '@nykaa/nes-auth-shared/types';
import { handleSocialLogin } from '@nykaa/nes-auth-shared/utils';
import { fetchTrueCallerScript } from 'shared/helpers/utils/autoFill';
import { isTrueCallerShown } from 'helpers/auth';
import {
  fetchRequestId,
  fetchTrueCallerStatus,
} from 'shared/store/app/actions';
import { State } from 'store/types';
import { getLogin, useManageEvents } from '../helpers';
import { loginPageName } from 'components/SignUp/helper';
import { getDeviceType } from 'components/Analytics/Initialize/helpers';
import { IOS } from 'constants/devices';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { AB_TRUECALLER } from 'constants/experiments';

const MobileLogin = ({
  showNudge,
  switchBtnCallback,
  hideSocialLogin,
}: WelcomeScreenProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { loading, message, mobile, isApiError, otpStatus, status } =
    useAuthData();
  const trueCallerConfig = useSelector(
    (state: State) => state.remoteConfig?.configs?.trueCaller
  );
  const isTrueCallerEnabled = useSelector((state: State) =>
    getEligibleForVariant(state, AB_TRUECALLER, 'A')
  );
  const isStatusFetching = useSelector(
    (state: State) => state?.appReducer.isTruecallerStatusFetching
  );
  const isCheckExistenceCaptchaEnabled = useSelector(
    (state: State) => state.appReducer.configFlags.auth.checkExistenceCaptcha
  );
  const device = useSelector(
    (state: State) => state.appReducer?.client?.device
  );

  useManageEvents(showNudge);

  const isOtpStatusError = otpStatus === false;

  useEffect(() => {
    if (status === false && message?.length > 0) {
      setError(true);
    }
  }, [message, status]);

  const handleLogin = useCallback(
    (emailPhone: string) => {
      getLogin({
        emailPhone,
        history,
        dispatch,
        setErrorMessage,
        setError,
        isCheckExistenceCaptchaEnabled,
      });
    },
    [dispatch, history, isCheckExistenceCaptchaEnabled]
  );

  const handleMobileFocus = useCallback(() => {
    const isDeviceIos = getDeviceType() === IOS;
    if (!isDeviceIos && !isTrueCallerShown()) {
      fetchTrueCallerScript({
        fetchRequestId,
        setGoogleOneTap: () => {},
        fetchTrueCallerStatus,
        trueCallerConfig,
        isStatusFetching,
        isTrueCallerEnabled,
        dispatch,
        setToastMessage: setErrorMessage,
        device,
      });
    }
  }, [
    dispatch,
    isStatusFetching,
    isTrueCallerEnabled,
    trueCallerConfig,
    device,
  ]);
  return (
    <>
      <MobileScreen
        subTitle={SUBTITLES.welcomeScreen}
        handleMobileFocus={handleMobileFocus}
        handleLogin={handleLogin}
        handleSocialLogin={handleSocialLogin}
        switchBtnCallback={switchBtnCallback}
        initialValue={mobile}
        isLoading={loading}
        isNudge={showNudge}
        loginPage={loginPageName()}
        hideSocialLogin={hideSocialLogin}
      />
      {(isError || isApiError || isOtpStatusError) && (
        <Toast
          timer={TOAST_TIMER}
          variant={VARIANT.single}
          message={errorMessage || message}
        />
      )}
    </>
  );
};

export default MobileLogin;
